<template>
    <v-row>
        <v-col cols="12">
            <v-row class="mx-sm-1 mx-0 my-sm-2 my-0">
                <v-col cols="12" class="px-sm-3 px-0">
                    <Waiver 
                        v-if="userStore"
                        ref="waiverYou"
                        :peopleSignatory="userStore"
                        :type="bandType"
                        :waiver="waiverItemIndex"
                        :languageWaiver="languageWaiver"
                    />
                </v-col>
                <v-col cols="12" >   
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        :color="buttonColor"
                        class="white--text"
                        @click="logout"
                        >
                        {{$t("layouts.login.logout",language)}}
                        </v-btn>
                        <v-btn
                        :color="buttonColor"
                        class="white--text"
                        @click="nextSignItem('Rejected')"
                        >
                        {{$t("eventWaiver.rejected",language)}}
                        </v-btn>
                        <v-btn
                        :color="buttonColor"
                        class="white--text"
                        @click="next('Signed')"
                        >
                        {{$t("eventWaiver.signed",language)}}
                        </v-btn>
                    </v-card-actions>
                </v-col>
            </v-row>
        </v-col>
         <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
    </v-row>
</template>

<script>
import { 
    VRow, VCol,VBtn, VCardActions, VSpacer
} from 'vuetify/lib';
import Waiver from "@/components/waiver/WaiverTemplate";
import LoginService from "@/services/LoginService";
import { mapState } from "vuex";
import Snack from "@/components/notifications/Snack";
import axios from "axios";

export default {
    components: {
        VRow, VCol,VBtn, VCardActions, VSpacer,
        Waiver,Snack
    },
    props: {
        waivers: {
            type: [Object]
        }
    },
    data() {
        return {
            buttonColor: "#000",
            waiverList: [],
            bandApprove: false,
            index: 0,
            bandType: "",
            snackbar: false,
            msg_snackbar: "",
            color_snackbar: "",
            currentIp: "",
            waiverItemIndex: false,
            languageWaiver: 'en'
        }
    },
    computed: {
        ...mapState({
            userStore: (state) => state.session.user
        }),
        firstContent() {
            if(this.waiverItemIndex && this.waiverItemIndex.content) {
                for (const property in this.waiverItemIndex.content) {
                    if(this.waiverItemIndex.content[property].available)
                        return this.waiverItemIndex.content[property]
            }
                        }
            return null;
        },
        language() {
            let language = this.$i18n.locale;
            if(this.waiverItemIndex && this.waiverItemIndex.content && this.waiverItemIndex.content[language] && Object.prototype.hasOwnProperty.call(this.waiverItemIndex.content[language],'available') && !this.waiverItemIndex.content[language].available) {
                language = this.firstContent ? this.firstContent.languageCode : language;
            }           
            return language;
        }
    },
    created() {
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    },
    mounted() {
        this.getIP();
        this.getData()
    },
    methods: {
        getData(){
            const waiver = this.$refs.waiverYou;
            this.waiverItemIndexM(this.waivers)
            this.waiversM(this.waivers)
            waiver.loadData(this.waivers)
        },
        getIP() {
            fetch(`${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/users/current/currentIp`)
            .then(x => x.json())
            .then(({ message }) => {
                this.currentIp = message;
            });
        },
        async logout() {
            LoginService.logout().then(response => {
                if(response.data.success == 1){
                if (typeof this.oldSystem === "undefined"){
                    this.$router.push({ name: 'Login' });
                } else {
                    window.location.href = this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+'/login?message=You20are%20logged%20out!';
                }
                }
            });
        },
        showSnackBar(){
            this.snackbar = true;
            this.msg_snackbar = this.$tc("common.invalid_step_4");
            this.color_snackbar = "error";
            setTimeout(() => this.snackbar = false, 3000);
        },
        next(waiverStatus) {
            let bandNext = false;
            if(this.$refs.waiverYou) {
                bandNext = this.$refs.waiverYou.nextSign();
            }
            if(!bandNext) {
                this.snackbar = true;
                this.msg_snackbar = this.$tc("eventWaiver.invalid_step_4");
                this.color_snackbar = "error";
                setTimeout(() => this.snackbar = false, 3000);
                return;
            }else{
                this.nextSignItem(waiverStatus)
            }
        },
        async nextSignItem(waiverStatus) {
            if(waiverStatus) {
                const waiverForm = this.$refs.waiverYou;
                const data = new FormData();
                data.append("eventWaiverSignedId", this.waiverItemIndex.id);
                data.append("waiverStatus", waiverStatus);
                data.append("ipAddress", this.currentIp);
                data.append("isNegligence", waiverForm.timeIsNegligence);
                data.append("isBoundParticipant", waiverForm.timeIsBoundParticipant);
                data.append("isBoundParent", waiverForm.timeIsBoundParent);
                data.append("isMinor", waiverForm.type === 'Minor' ? 1 : 0);
                data.append("languageCode", waiverForm.language);

                if(waiverStatus=='Signed'){
                    data.append("iAgree", waiverForm.timeIAgree);
                    data.append("isCertify", waiverForm.timeIsCorrect || waiverForm.timeIsCorrectMinor);
                    data.append("isConsent", waiverForm.timeIsConsent);
                    data.append("signature", waiverForm.signature);
                    if(waiverForm.isPictureRequired) {
                        data.append("selfie", waiverForm.selfie);
                    }
                    data.append("isAgreedText", waiverForm.timeIAgreeLabel || "");
                    data.append("isNegligenceText", waiverForm.timeIsNegligenceLabel || "");
                    data.append("isCertifyText", waiverForm.timeIsCorrectLabel || "");
                    data.append("isCertifyMinorText", waiverForm.timeIsCorrectMinorLabel || "");
                    data.append("isBoundParticipantText", waiverForm.timeIsBoundParticipantLabel || "");
                    data.append("isBoundParentText", waiverForm.timeIsBoundParentLabel || "");
                    data.append("isConsentText", waiverForm.timeIsConsentLabel || "");
                    data.append("voluntarilyText", waiverForm.$t("eventWaiver.voluntarily_text", waiverForm.language));
                    data.append("negligenceText", waiverForm.negligenceParagraph || "");
                    data.append("boundAgreementText", waiverForm.boundAgreementParagraph || "");
                }

                let axiosConfig = {
                    headers: { "content-type": "multipart/form-data" },
                };
                const response = await axios.put(`${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/participant/waivers/saveSignature`, data, axiosConfig);
                if(response.data.success) {
                    this.waiverItemIndex.statusReview = true;
                    this.waiverItemIndex.isAgreedChk = response.data.message.isAgreedChk;
                    this.waiverItemIndex.isElectronicConsentChk = response.data.message.isElectronicConsentChk;
                    this.waiverItemIndex.isCertifyChk = response.data.message.isCertifyChk;
                    this.waiverItemIndex.signatureImage = response.data.message.signatureImage;
                    if(this.waiverItemIndex.isPictureRequired) this.waiverItemIndex.selfie = response.data.message.signatoryPicture;
                    if(this.waiverList.filter((el) => !el.statusReview).length == 0) {
                        this.bandApprove = true;
                        if(this.index == (this.waiverList.length - 1)) 
                            this.next();
                        else 
                            this.index++;
                    } else {
                        this.index++;
                    }
                    this.$emit('nextSignItem');
                } else {
                    this.$emit('showSnackBar', { msg: this.$tc("common.error_general"), color: "error" });
                    return;
                }
            }
        },
        backWaiver() {
            if(this.index > 0) this.index--;
        },
        waiverItemIndexM(val) {
            const waiver = this.$refs.waiverYou; 
            if(waiver && waiver.$refs.formWaiver) {
                waiver.$refs.formWaiver.resetValidation();
                waiver.loadData(val);
            }
                
        },
        waiversM(val) {
            if(val) {
                const item = this.waiverList.find((el1) => {
                    return val.fkEventWaiverSId == el1.eventWaiverSId;
                });
                if(!item) {
                    this.waiverList.push({
                        ...val,
                        statusReview: val.waiverStatus == "Signed"
                    });
                }
                if(this.index >= 0 && this.index < this.waiverList.length) {
                    const birthdayCurrent = this.waiverList[this.index].participantDateOfBirth;
                    if(birthdayCurrent) {
                            if(this.waiverList[this.index].ageTarget == "Adult") {
                                this.bandType = 'Adult';
                            } else {
                                this.bandType = 'Minor';
                            }
                    } else {
                            this.bandType = 'Adult';
                    }
                    this.waiverItemIndex = this.waiverList[this.index];
                    if(this.waiverItemIndex) {
                        this.languageWaiver = this.waiverItemIndex.languageCode ? this.waiverItemIndex.languageCode : null;
                }
            }
        }
        }
    },
    watch: {
        waiverItemIndex(val) {
            const waiver = this.$refs.waiverYou; 
            if(waiver && waiver.$refs.formWaiver) {
                waiver.$refs.formWaiver.resetValidation();
                waiver.loadData(val);
            }
                
        },
        waivers(val) {
            if(val) {
                const item = this.waiverList.find((el1) => {
                    return val.fkEventWaiverSId == el1.eventWaiverSId;
                });
                if(!item) {
                    this.waiverList.push({
                        ...val,
                        statusReview: val.waiverStatus == "Signed"
                    });
                }
                if(this.index >= 0 && this.index < this.waiverList.length) {
                    const birthdayCurrent = this.waiverList[this.index].participantDateOfBirth;
                    if(birthdayCurrent) {
                            if(this.waiverList[this.index].ageTarget == "Adult") {
                                this.bandType = 'Adult';
                            } else {
                                this.bandType = 'Minor';
                            }
                    } else {
                            this.bandType = 'Adult';
                    }
                    this.waiverItemIndex = this.waiverList[this.index];
                    if(this.waiverItemIndex) {
                        this.languageWaiver = this.waiverItemIndex.languageCode ? this.waiverItemIndex.languageCode : null;
                    }
                }
            }
        }
    }
}
</script>